import { FC } from 'react'
import type { IconProps } from '../../types'

const OnVerification: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z'
      fill='#CC7400'
      stroke='white'
      strokeWidth='2'
    />
    <path
      d='M12.0002 15.75C12.6906 15.75 13.2502 16.3096 13.2502 17C13.2502 17.6904 12.6906 18.25 12.0002 18.25C11.3099 18.25 10.7502 17.6904 10.7502 17C10.7502 16.3096 11.3099 15.75 12.0002 15.75Z'
      fill='white'
    />
    <path
      d='M12.0002 5.75C12.6906 5.75 13.2502 6.30964 13.2502 7V13.25C13.2502 13.9404 12.6906 14.5 12.0002 14.5C11.3099 14.5 10.7502 13.9404 10.7502 13.25V7C10.7502 6.30964 11.3099 5.75 12.0002 5.75Z'
      fill='white'
    />
  </svg>
)

export default OnVerification
